import { FormField } from "@/components/ui/form";
import { Switch } from "@/components/ui/switch";
import { memo, useCallback } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { TimePicker } from "./TimePicker";
import { ChildrenSelector } from "./ChildrenSelector";
import { type PeriodScheduleProps } from "./types";
import { filterEndTimeOptions } from "./types";

export const PeriodSchedule = memo(function PeriodSchedule({ day, periodKey, periodLabel, startTimeOptions }: PeriodScheduleProps) {
  const form = useFormContext();

  // Use useWatch for more efficient form value watching
  const isActive = useWatch({
    control: form.control,
    name: `openingHours.${day}.${periodKey}.active`,
  });

  const startTime = useWatch({
    control: form.control,
    name: `openingHours.${day}.${periodKey}.start`,
  });

  const handleActiveChange = useCallback(
    (checked: boolean) => {
      form.setValue(`openingHours.${day}.${periodKey}.active`, checked);
    },
    [form, day, periodKey]
  );

  const filteredEndTimeOptions = filterEndTimeOptions(startTime);

  return (
    <div className="flex min-w-0 flex-1 flex-col space-y-4">
      <div className="flex items-center gap-1 justify-between">
        <div className="font-medium text-gray-900">{periodLabel}</div>
        <FormField
          control={form.control}
          name={`openingHours.${day}.${periodKey}.active`}
          render={({ field }) => <Switch checked={field.value} onCheckedChange={handleActiveChange} className="data-[state=checked]:bg-blue-600" />}
        />
      </div>

      {isActive && (
        <div className="space-y-4">
          <TimePicker day={day} period={periodKey} label="Début" fieldName="start" options={startTimeOptions} />
          <TimePicker day={day} period={periodKey} label="Fin" fieldName="end" options={filteredEndTimeOptions} />
          <ChildrenSelector day={day} period={periodKey} />
        </div>
      )}
    </div>
  );
});
